import removeImg from "../../../assets/images/remove-icon.svg";
import formatText from "../formatText/FormatText";

const CommonChip = ({
  unitName = "Value",
  onRemove,
  backgroundColor = "#fff",
  color = false,
  fontSize = "16px",
}) => {
  const handleRemoveClick = () => {
    if (onRemove) {
      onRemove(unitName);
    }
  };

  if (unitName === "" || unitName === null) return null;

  return (
    <div className="inline-block">
      <div
        className="flex items-center border border-gray-700 rounded-full px-2 py-1 cursor-pointer"
        style={{
          backgroundColor: backgroundColor,
          fontSize: fontSize,
          fontFamily: "inherit",
          color: color ? "#fff" : "inherit",
        }}
      >
        <span>{formatText(unitName)}</span>
        <img
          src={removeImg}
          alt={`${unitName} img`}
          onClick={handleRemoveClick}
          className="ml-2 w-2.5 h-2.5 cursor-pointer"
          style={{
            filter: !color ? "brightness(1) invert(1)" : "none",
          }}
        />
      </div>
    </div>
  );
};

export default CommonChip;
